export default {
  data () {
    return {
      evoiceIntermediariesUnprocessed: [
        // Banks
        { id: 'HELSFIHH', name: 'Aktia HELSFIHH' },
        { id: 'DABAFIHH', name: 'Danske Bank DABAFIHH' },
        { id: 'DNBAFIHX', name: 'DNB DNBAFIHX' },
        { id: 'HANDFIHH', name: 'Handelsbanken HANDFIHH' },
        { id: 'NDEAFIHH', name: 'Nordea Pankki NDEAFIHH' },
        { id: 'ITELFIHH', name: 'Säästöpankki ITELFIHH' },
        { id: 'OKOYFIHH', name: 'Osuuspankit ja Pohjola Pankki OKOYFIHH' },
        { id: 'POPFFI22', name: 'POP Pankki POPFFI22' },
        { id: 'SBANFIHH', name: 'S-Pankki/LähiTapiola SBANFIHH' },
        { id: 'AABAFI22', name: 'Ålandsbanken AABAFI22' },
        // Operators
        { id: 'UTMOST', name: '4US Oy UTMOST' },
        { id: '003723327487', name: 'Apix Messaging Oy 003723327487' },
        { id: 'APPER', name: 'Apper Systems AB APPER' },
        { id: 'BAWCFI22', name: 'Basware Oyj BAWCFI22' },
        { id: '003703575029', name: 'CGI Suomi (ent. Logica) 003703575029' },
        { id: '5909000716438', name: 'Comarch 5909000716438' },
        { id: 'CREDIFLOW', name: 'Crediflow AB CREDIFLOW' },
        { id: 'ROUTTY', name: 'Dynatos ROUTTY' },
        { id: '885790000000418', name: 'HighJump AS 885790000000418' },
        { id: 'INEXCHANGE', name: 'InExchange Factorum AB INEXCHANGE' },
        { id: 'EXPSYS', name: 'Kofax Sweden Services AB EXPSYS' },
        { id: '981012224', name: 'LOGIQ AS 981012224' },
        { id: '003721291126', name: 'Maventa 003721291126' },
        { id: '003726044706', name: 'Netbox Finland Oy 003726044706' },
        { id: '003708599126', name: 'Opentext Oy (ent. Liaison Technologies Oy) 003708599126' },
        { id: 'E204503', name: 'OpusCapita Solutions Oy E204503' },
        { id: '003723609900', name: 'Pagero Oy 003723609900' },
        { id: 'FI28768767', name: 'Posti Messaging Oy FI28768767' },
        { id: '003701150617', name: 'PostNord Strålfors Oy 003701150617' },
        { id: '003714377140', name: 'Ropo Capital Oy 003714377140' },
        { id: '003703575029', name: 'Telia Finland Oyj 003703575029' },
        { id: '003701011385', name: 'TietoEvry Oyj 003701011385' },
        { id: '885060259470028', name: 'Tradeshift Ab 885060259470028' },
        { id: '003722207029', name: 'Ålands Post Ab 003722207029' },
        // Special butterflies
        { id: 'PEPPOL', name: 'Peppol PEPPOL' },
        { id: 'SPROOM', name: 'Sproom ApS SPROOM' },
        // Removed?
        /*
        { id: '003717203971', name: 'Notebeat Oy 003717203971' },
        { id: 'PALETTE', name: 'Palette Software PALETTE' },
        { id: '003714756079', name: 'TeliaSonera Finland Oyj 003714756079' },
        */
      ]
    }
  },
  computed: {
    evoiceInt () {
      return this.evoiceIntermediariesUnprocessed.sort((a, b) => a.name > b.name ? 1 : -1)
    }
  }
}